import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ConnectivityLoadIcon = ({
  color,
  height = 32,
  width = 32,
  ...rest
}: {
  color?: string;
  height?: number;
  width?: number;
}) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorPrimary;

  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 29C21.5787 29 26.3367 25.486 28.1812 20.5507L7.1991 25.568C9.51447 27.6988 12.6053 29 16 29ZM28.6758 18.1993C28.7236 18.1878 28.7714 18.1795 28.819 18.1741C28.938 17.4672 29 16.7408 29 16C29 15.2592 28.938 14.5328 28.819 13.8259C28.7714 13.8205 28.7236 13.8122 28.6758 13.8007L6.0248 8.38443C5.86769 8.34687 5.72653 8.2796 5.60622 8.19046C3.96989 10.3648 3 13.0691 3 16C3 18.9309 3.96989 21.6352 5.60622 23.8095C5.72653 23.7204 5.86769 23.6531 6.0248 23.6156L28.6758 18.1993ZM7.1991 6.43203C9.51447 4.30119 12.6053 3 16 3C21.5787 3 26.3367 6.51398 28.1812 11.4493L7.1991 6.43203Z"
        fill={currentColor}
      />
    </svg>
  );
};

export default ConnectivityLoadIcon;
